<template>
  <div id="jura-app">
    <appHeader></appHeader>
    <appNav></appNav>
    <router-view></router-view>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from './components/Header'
import Nav from './components/Nav'
import Footer from './components/Footer'

export default {
  name: 'app',
  components: {
    appHeader: Header,
    appNav: Nav,
    appFooter: Footer
  },
  watch: {
    $route (to, from) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="scss">
#jura-app {
  font-family: 'LatoWebMedium';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #555555;

  h1 {
    font-family: 'LatoWebLight';
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue